/**
 * Aceleres -- fonte unica da URL base do Laravel.
 *
 * Antes cada componente repetia a mesma heuristica de hostname, com duas
 * consequencias em producao:
 *
 * 1. `app.zoraxy.ai` casa com 'zoraxy', entao a producao chamava o Laravel de
 *    HOMOLOG. Nos hosts com o proxy same-origin do nginx (`location
 *    /aceleres-api/`) devolvemos o caminho relativo, que tambem resolve a perda
 *    do cookie de sessao numa chamada cross-site.
 * 2. Varios arquivos fixavam o dominio na mao (ora o de producao, ora o de
 *    homolog), entao o ambiente errado era chamado dependendo da tela.
 *
 * Quem precisar da URL do Laravel deve importar daqui em vez de reimplementar.
 */

// Hosts cujo nginx expoe o proxy same-origin /aceleres-api/.
const SAME_ORIGIN_PROXY_HOSTS = ['app.zoraxy.ai', 'atendimento.zoraxy.ai'];

export const resolveAceleresApiBase = () => {
  const host = String(window.location.hostname || '').toLowerCase();

  if (SAME_ORIGIN_PROXY_HOSTS.includes(host)) return '/aceleres-api';
  if (host === 'atendimento.zoraxy.ai') return 'https://homolog.aceleres.ai';
  if (host === 'atendimento.aceleres.ai') return 'https://aceleres.ai';
  // Demais vhosts de desenvolvimento (*.zoraxy.ai, *homolog*) continuam
  // apontando para o Laravel de homolog.
  if (host.includes('zoraxy') || host.includes('homolog')) {
    return 'https://homolog.aceleres.ai';
  }

  return 'https://aceleres.ai';
};

/**
 * Para NAVEGAR ate o painel do Laravel (window.location / window.open), e nao
 * para chamar a API. O proxy `/aceleres-api` serve requisicoes, nao paginas:
 * mandar o usuario para la abriria o caminho errado.
 *
 * Em producao o destino e `acelerity.ai`. O antigo `aceleres.ai` so sobrevive
 * como 301 para ele, entao navegar para la custa um salto a toa (e, se algum
 * dia virasse chamada de API, o 301 cross-domain perderia cookie e
 * cabecalhos). O host legado `atendimento.aceleres.ai` continua casando com
 * `aceleres.ai` de proposito.
 */
export const resolveAceleresSiteUrl = () => {
  const host = String(window.location.hostname || '').toLowerCase();

  if (host === 'app.zoraxy.ai') return 'https://acelerity.ai';
  if (host === 'atendimento.zoraxy.ai') return 'https://homolog.aceleres.ai';
  if (host.includes('zoraxy') && host !== 'app.zoraxy.ai') {
    return 'https://homolog.aceleres.ai';
  }
  if (host.includes('homolog')) return 'https://homolog.aceleres.ai';

  return 'https://aceleres.ai';
};

export default resolveAceleresApiBase;
